import { superAdminAccess } from "../../../helpers/system-config";
import CommonManager from "../../../helpers/common";

const commonManager = new CommonManager();

const showRegion = (currentUser) => {
  return (
    superAdminAccess.includes(currentUser.role) && {
      name: "Region",
      link: "/organization-settings/region",
      disabled: false,
      active: false,
      accessName: "",
      index: 3,
    }
  );
};

const showFlowTemplate = (currentUser) => {
  return (
    superAdminAccess.includes(currentUser.role) && {
      name: "Flow Template",
      link: "/organization-settings/flow-template",
      disabled: false,
      active: false,
      accessName: "",
      index: 3,
    }
  );
};

const showTTSProvider = (currentUser) => {
  return (
    superAdminAccess.includes(currentUser.role) && {
      name: "TTS Provider",
      link: "/organization-settings/tts-provider",
      disabled: false,
      active: false,
      accessName: "",
      index: 3,
    }
  );
};

const showTTSModel = (currentUser) => {
  return (
    superAdminAccess.includes(currentUser.role) && {
      name: "TTS Model",
      link: "/organization-settings/tts-model",
      disabled: false,
      active: false,
      accessName: "",
      index: 3,
    }
  );
};

const showSTTProvider = (currentUser) => {
  return (
    superAdminAccess.includes(currentUser.role) && {
      name: "STT Provider",
      link: "/organization-settings/stt-provider",
      disabled: false,
      active: false,
      accessName: "",
      index: 3,
    }
  );
};

const showSTTModel = (currentUser) => {
  return (
    superAdminAccess.includes(currentUser.role) && {
      name: "STT Model",
      link: "/organization-settings/stt-model",
      disabled: false,
      active: false,
      accessName: "",
      index: 3,
    }
  );
};

const showLLMProvider = (currentUser) => {
  return (
    superAdminAccess.includes(currentUser.role) && {
      name: "LLM Provider",
      link: "/organization-settings/llm-provider",
      disabled: false,
      active: false,
      accessName: "",
      index: 3,
    }
  );
};

const showLLMModel = (currentUser) => {
  return (
    superAdminAccess.includes(currentUser.role) && {
      name: "LLM Model",
      link: "/organization-settings/llm-model",
      disabled: false,
      active: false,
      accessName: "",
      index: 3,
    }
  );
};

// Function to generate the menu list based on the current user
export const createMenuList = (currentUser) => {
  return [
    {
      name: "Account Setting",
      display: commonManager.displayHeader([
        "account-setting",
        "plans-and-billing",
      ]),
      keepClosed: true,
      isShow: "none",
      color: "#ffff",
      arrow: "keyboard_double_arrow_down",
      childs: [
        showRegion(currentUser),
        showFlowTemplate(currentUser),
      ].filter(Boolean), // Filter out falsy values
    },
    {
      name: "Text To Speech",
      display: commonManager.displayHeader([
        "account-setting",
        "plans-and-billing",
      ]),
      keepClosed: true,
      isShow: "none",
      color: "#ffff",
      arrow: "keyboard_double_arrow_down",
      childs: [
        showTTSProvider(currentUser),
        showTTSModel(currentUser),
      ].filter(Boolean),
    },
    {
      name: "Speech To Text",
      display: commonManager.displayHeader([
        "account-setting",
        "plans-and-billing",
      ]),
      keepClosed: true,
      isShow: "none",
      color: "#ffff",
      arrow: "keyboard_double_arrow_down",
      childs: [
        showSTTProvider(currentUser),
        showSTTModel(currentUser),
      ].filter(Boolean),
    },
    {
      name: "Large Language Model",
      display: commonManager.displayHeader([
        "account-setting",
        "plans-and-billing",
      ]),
      keepClosed: true,
      isShow: "none",
      color: "#ffff",
      arrow: "keyboard_double_arrow_down",
      childs: [
        showLLMProvider(currentUser),
        showLLMModel(currentUser),
      ].filter(Boolean),
    },
  ];
};



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/List.js